import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';

import { CBMError, Contract, User } from 'app/models';
import { ContractService, UserService } from 'app/services';
import { DateUtil } from 'app/utils';

@Component({
  selector: 'app-admin-user-detail',
  templateUrl: './admin-user-detail.component.html',
  styleUrls: ['./admin-user-detail.component.scss']
})
export class AdminUserDetailComponent implements OnInit {
  private id: number;
  private isNewUser = true;

  public languages = ['nl', 'gb'];
  public userNotFound = false;
  public user: User = new User(null, null, null, null, 'nl', true);
  public activeUntilDate: string;
  public contractLinks: { contract: Contract; linked: boolean }[] = [];
  public isSaving = false;

  public errorMessages: CBMError[] = [];

  constructor(
    private readonly userService: UserService,
    private readonly contractService: ContractService,
    private readonly dateUtil: DateUtil,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });

    if (this.id != null) {
      this.isNewUser = false;
      this.userService.getUser(this.id).subscribe(
        user => {
          this.user = user;
          this.activeUntilDate = this.dateUtil.dashesToSlashes(user.activeUntil);
          this.getContracts();
        },
        (errors: CBMError[]) => {
          this.errorMessages = errors;
          this.userNotFound = true;
        }
      );
    } else {
      this.getContracts();
    }
  }

  linkUserContracts(allContracts: Contract[]) {
    this.contractLinks = [];

    if (allContracts && allContracts.length > 0) {
      for (const contract of allContracts) {
        this.contractLinks.push({
          contract,
          linked: this.userHasContract(contract)
        });
      }
    }
  }

  userHasContract(contract: Contract): boolean {
    if (this.user.contracts == null || this.user.contracts.length === 0) {
      return false;
    }

    for (const userContract of this.user.contracts) {
      if (userContract.id === contract.id) {
        return true;
      }
    }
    return false;
  }

  getContracts() {
    this.contractService.getContracts().subscribe(
      contracts => this.linkUserContracts(contracts),
      (errors: CBMError[]) => {
        this.errorMessages = errors;
      }
    );
  }

  backToUserOverview(): void {
    this.router.navigate(['/admin/users']);
  }

  onSubmit() {
    this.errorMessages = [];
    this.isSaving = true;

    this.user.contracts = this.contractLinks.filter(link => link.linked).map(link => link.contract);

    // Reformat the active until date
    if (this.activeUntilDate != null) {
      this.user.activeUntil = this.dateUtil.slashesToDashes(this.activeUntilDate);
    }

    // create or update the user
    let observable: Observable<User>;
    if (this.isNewUser) {
      observable = this.userService.createUser(this.user);
    } else {
      observable = this.userService.updateUser(this.user);
    }

    observable.subscribe(
      savedUser => this.backToUserOverview(),
      (errors: CBMError[]) => {
        console.log(errors);
        this.errorMessages = errors;
      }
    );

    this.isSaving = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/admin-user-detail.component.ts